const { pipe, values, flatten } = require('ramda');

const EN = 'en';
const DE = 'de';
const DEFAULT_LANGUAGE = EN;
const LANGS = [DE, EN];

const LOCALES = ['contact', 'whatWeDo', 'whoWeAre', 'app', 'tags', 'search', 'footer', 'form', 'translation'];

const TAGS_OBJECT = {
  medicine: ['eye', 'telemedicine', 'mobilehealth', 'knowledge', 'musculoskeletal'],
  research: ['statistic', 'ethics', 'reviews'],
  technology: ['softwarearchitecture', 'dataarchitecture', 'engineering', 'security'],
  design: ['ui', 'ci', 'ux'],
  business: ['businessmodel', 'regulatory', 'funding', 'servicedesign', 'csr', 'pm', 'administration', 'marketing', 'patents', 'law', 'startup'],
};
TAGS_OBJECT.medignition = pipe(values, flatten)(TAGS_OBJECT);
TAGS_OBJECT.innovation = TAGS_OBJECT.medignition;
TAGS_OBJECT.product = TAGS_OBJECT.medignition;
TAGS_OBJECT.solution = TAGS_OBJECT.medignition;

const contactItems = [
  {
    title: 'investors',
    link: '/contacts/investors',
  },
  {
    title: 'partners',
    link: '/contacts/partners',
  },
  {
    title: 'general',
    link: '/contacts',
  },
];

module.exports = {
  EN, DE, DEFAULT_LANGUAGE, LANGS, LOCALES, TAGS_OBJECT, contactItems,
};
